import React, { useMemo, useState } from 'react';
import styles from './tutorialModal.module.css';
import { BookIcon, CloseIcon, HelpIcon, } from '../../../assets/icons/svgIcons';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import SubscriptionsOutlinedIcon from '@material-ui/icons/SubscriptionsOutlined';
import PlayCircleFilledWhiteOutlinedIcon from '@material-ui/icons/PlayCircleFilledWhiteOutlined';
import MenuBookOutlinedIcon from '@material-ui/icons/MenuBookOutlined';
import TutorialViewer from '../tutorialViewer/tutorialViewer';
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../reducers/userSlice';


export const TutorialButton = ({ data = [], }) => {

    const user = useSelector(selectUser);
    const [openModalHTMLContent, setOpenModalHTMLContent] = useState(false);

    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);
    const routePath = location.pathname;

    const filteredData = useMemo(() => {
        return data.find(item => item.route === routePath);
    }, [data, routePath]);

    const handleCloseModal = () => {
        setIsOpen(false);
        setOpenModalHTMLContent(false);
    };

    const handleTutorialClick = (item, type) => {
        const url = type === 'video' ? item.videoLink : type === 'htmlContent' ? item.htmlContent : item.pdf;

        if (!url) return;

        if (type === 'video') {
            window.open(url, '_blank', 'noopener,noreferrer');
        } else if (type === 'htmlContent') {
            setOpenModalHTMLContent(true);
        } else {
            // Lógica para descargar PDF
            const link = document.createElement('a');
            link.href = url;
            // Usamos el 'route' o 'app' como nombre sugerido, ya que no hay 'title'
            link.download = `tutorial-${item.app}-${item._id}.pdf`;
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    if (!data || data.length === 0 || !filteredData) return null;
    if (!filteredData?.htmlContent && !filteredData?.pdf && !filteredData?.videoLink) return null
    if (user?.email !== "lumarketo.desarrollo@gmail.com") return null;
    console.log("filteredData", filteredData);
    console.log("data", data);
    return (
        <>
            {/* Botón Flotante */}
            <button
                onClick={() => setIsOpen(true)}
                className={styles.floatingButton}
                title="Ver tutoriales"
            >
                <HelpIcon />
                <span>¿Necesitas ayuda?</span>

            </button>

            {/* Modal Overlay */}
            {isOpen && (
                <div className={styles.overlay}>
                    {/* Backdrop (fondo oscuro) */}
                    <div
                        className={styles.backdrop}
                        onClick={() => setIsOpen(false)}
                    />

                    {/* Contenido del Modal */}
                    {openModalHTMLContent ?
                        <div className={styles.modalHtml}>

                            {/* Header */}
                            <div className={styles.header}>

                                {/* Círculos decorativos */}
                                <div className={styles.headerCircle1}></div>
                                <div className={styles.headerCircle2}></div>

                                <div className={styles.headerContent}>

                                    <div className={styles.headerTitleBoxContainerBack}>

                                        <button type="button" onClick={() => setOpenModalHTMLContent(false)} className={styles.backBtn}>
                                            <ArrowBackOutlinedIcon style={{ color: 'white' }} />
                                        </button>
                                        <div className={styles.headerTitleBox}>
                                            <div className={styles.headerIconBox}>
                                                <HelpIcon />
                                            </div>
                                            <div>
                                                {filteredData?.title ? <h2 className={styles.title}>{filteredData?.title}</h2> : <h2 className={styles.title}>Tutoriales</h2>}
                                                {filteredData?.description ? <p className={styles.subtitle}>{filteredData?.description}</p> : <p className={styles.subtitle}>Aprende sobre esta sección</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <button
                                        onClick={() => handleCloseModal()}
                                        className={styles.closeButton}
                                    >
                                        <CloseIcon />
                                    </button>
                                </div>
                            </div>
                            <div className={styles.modalHtmlContent}>
                                <TutorialViewer htmlContent={filteredData.htmlContent} />
                            </div>
                            {/* Footer */}
                            <div className={styles.footer}>
                                <p className={styles.footerText}>
                                    ¿Necesitas más ayuda? Contacta a soporte técnico
                                </p>
                            </div>
                        </div>

                        :
                        <div className={styles.modal}>

                            {/* Header */}
                            <div className={styles.header}>



                                {/* Círculos decorativos */}
                                <div className={styles.headerCircle1}></div>
                                <div className={styles.headerCircle2}></div>

                                <div className={styles.headerContent}>
                                    <div className={styles.headerTitleBox}>
                                        <div className={styles.headerIconBox}>
                                            <HelpIcon />
                                        </div>
                                        <div>
                                            {filteredData?.title ? <h2 className={styles.title}>{filteredData?.title}</h2> : <h2 className={styles.title}>Tutoriales</h2>}
                                            {filteredData?.description ? <p className={styles.subtitle}>{filteredData?.description}</p> : <p className={styles.subtitle}>Aprende sobre esta sección</p>}
                                        </div>
                                    </div>
                                    <button
                                        onClick={() => handleCloseModal()}
                                        className={styles.closeButton}
                                    >
                                        <CloseIcon />
                                    </button>
                                </div>
                            </div>

                            <div className={styles.listContainer}>
                                <div className={styles.grid}>
                                    {filteredData && filteredData?.pdf &&

                                        <div
                                            className={styles.card}
                                            onClick={() => handleTutorialClick(filteredData, 'pdf')}
                                        >
                                            <div className={styles.cardContent}>
                                                <div className={classNames(styles.iconWrapper, styles.pdfWrapper)}>
                                                    <DescriptionOutlinedIcon className={styles.pdfIcon} />

                                                </div>

                                                <div className={styles.cardBody}>
                                                    <div className={styles.cardHeader}>
                                                        <h3 className={styles.cardTitle}>
                                                            Descarga una guía escrita para esta sección                                                    </h3>
                                                    </div>

                                                    {/*  <p className={styles.cardDesc}>
                                                    Documentación oficial para{
                                                </p> */}

                                                    {/* Botón de Acción */}
                                                    <div className={classNames(styles.actionBadge, styles.pdfBadge)}>
                                                        <GetAppOutlinedIcon className={styles.downloadIcon} />
                                                        <span>
                                                            Descargar PDF
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    }   {filteredData && filteredData?.videoLink &&

                                        <div
                                            className={styles.card}
                                            onClick={() => handleTutorialClick(filteredData, 'video')}
                                        >
                                            <div className={styles.cardContent}>
                                                <div className={classNames(styles.iconWrapper, styles.videoWrapper)}>
                                                    <SubscriptionsOutlinedIcon className={styles.videoIcon} />

                                                </div>

                                                <div className={styles.cardBody}>
                                                    <div className={styles.cardHeader}>
                                                        <h3 className={styles.cardTitle}>
                                                            Mira un video tutorial para esta sección                                                    </h3>
                                                    </div>

                                                    {/*  <p className={styles.cardDesc}>
                                                    Documentación oficial para{
                                                </p> */}

                                                    {/* Botón de Acción */}
                                                    <div className={classNames(styles.actionBadge, styles.videoBadge)}>
                                                        <PlayCircleFilledWhiteOutlinedIcon className={styles.playIcon} />
                                                        <span>
                                                            Ver video
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    }

                                    {filteredData && filteredData?.htmlContent &&

                                        <div
                                            className={styles.card}
                                            onClick={() => handleTutorialClick(filteredData, 'htmlContent')}
                                        >
                                            <div className={styles.cardContent}>
                                                <div className={classNames(styles.iconWrapper, styles.htmlWrapper)}>
                                                    <BookIcon />

                                                </div>

                                                <div className={styles.cardBody}>
                                                    <div className={styles.cardHeader}>
                                                        <h3 className={styles.cardTitle}>
                                                            Lee el tutorial en su versión web                                                  </h3>
                                                    </div>

                                                    <div className={classNames(styles.actionBadge, styles.htmlBadge)}>
                                                        <MenuBookOutlinedIcon className={styles.bookIcon} />
                                                        <span>
                                                            Leer tutorial
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    }

                                </div>

                                {/* Estado Vacío (por seguridad, aunque el return null inicial lo evita) */}
                                {!filteredData && (
                                    <div className={styles.emptyState}>
                                        <div className={styles.emptyIconBox}>
                                            <HelpIcon />                                    </div>
                                        <h3 className={styles.cardTitle}>No hay tutoriales disponibles</h3>
                                        <p className={styles.cardDesc}>Pronto agregaremos contenido aquí.</p>
                                    </div>
                                )}
                            </div>

                            {/* Footer */}
                            <div className={styles.footer}>
                                <p className={styles.footerText}>
                                    ¿Necesitas más ayuda? Contacta a soporte técnico
                                </p>
                            </div>
                        </div>}
                </div>
            )}
        </>
    );
}